import { UserType } from 'modules/User';
import { ReactElement, Suspense, lazy } from 'react';

// Components are split and lazy-loaded to reduce the initial bundle size
const ImageGridPack = lazy(
  () =>
    import(
      /* webpackChunkName: "ImageGridMenuPack" */
      /* webpackPrefetch: true */
      './ElementsMenuPacks/ImageGridPack'
    ),
);

const TextBlockPack = lazy(
  () =>
    import(
      /* webpackChunkName: "TextBlockMenuPack" */
      /* webpackPrefetch: true */
      './ElementsMenuPacks/TextBlockPack'
    ),
);

const SignaturePack = lazy(
  () =>
    import(
      /* webpackChunkName: "SignatureMenuPack" */
      /* webpackPrefetch: true */
      './ElementsMenuPacks/SignaturePack'
    ),
);

const ImageFramePack = lazy(
  () =>
    import(
      /* webpackChunkName: "ImageFrameMenuPack" */
      /* webpackPrefetch: true */
      './ElementsMenuPacks/ImageFramePack'
    ),
);

const ListPack = lazy(
  () =>
    import(
      /* webpackChunkName: "ListMenuPack" */
      /* webpackPrefetch: true */
      './ElementsMenuPacks/ListPack'
    ),
);

interface ImageGridMenuPackProps {
  onClickUpgradeModal: (upgradePlan?: UserType) => void;
}

export const ImageGridMenuPack = ({ onClickUpgradeModal }: ImageGridMenuPackProps): ReactElement => (
  <Suspense fallback={<div>loading..</div>}>
    <ImageGridPack onClickUpgradeModal={onClickUpgradeModal} />
  </Suspense>
);

interface TextBlockMenuPackProps {
  onClickUpgradeModal: (upgradePlan?: UserType) => void;
}

export const TextBlockMenuPack = ({ onClickUpgradeModal }: TextBlockMenuPackProps): ReactElement => (
  <Suspense fallback={<div>loading..</div>}>
    <TextBlockPack onClickUpgradeModal={onClickUpgradeModal} />
  </Suspense>
);

interface SignatureMenuPackProps {
  onClickUpgradeModal: (upgradePlan?: UserType) => void;
}

export const SignatureMenuPack = ({ onClickUpgradeModal }: SignatureMenuPackProps): ReactElement => (
  <Suspense fallback={<div>loading..</div>}>
    <SignaturePack onClickUpgradeModal={onClickUpgradeModal} />{' '}
  </Suspense>
);

interface ListMenuPackProps {
  onClickUpgradeModal: (upgradePlan?: UserType) => void;
}

export const ListMenuPack = ({ onClickUpgradeModal }: ListMenuPackProps): ReactElement => (
  <Suspense fallback={<div>loading..</div>}>
    <ListPack onClickUpgradeModal={onClickUpgradeModal} />
  </Suspense>
);

interface ImageFrameMenuPackProps {
  onClickUpgradeModal: (upgradePlan?: UserType) => void;
}

export const ImageFrameMenuPack = ({ onClickUpgradeModal }: ImageFrameMenuPackProps): ReactElement => (
  <Suspense fallback={<div>loading..</div>}>
    <ImageFramePack onClickUpgradeModal={onClickUpgradeModal} />
  </Suspense>
);
